import { ApiErrorResponse } from '@/api/shared.types.ts';

export const transformToApiError = (error: unknown): ApiErrorResponse => {
  return {
    success: false,
    error: {
      code: 500,
      message:
        error instanceof Error
          ? error.message
          : 'Unexpected error, please try again',
    },
  };
};
